import React from "react";
import { CtaButton } from "../CtaButton";
export function Problem() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-241" data-mp="2wfdhn5vgwkxa">
      <div className="mx-auto max-w-3xl px-5" data-id="element-242" data-mp="2whhkrlljlfwi">
        <h2 id="problem-title" className="text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-243" data-mp="2rndd104gd3ud">
          I created this for the physical therapist who knows the theory…{" "}
          <em className="text-brand" data-id="element-244" data-mp="2hr0i5yx68jy1">but wants a clearer system for putting it into practice.</em>
        </h2>

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-245" data-mp="2cpl08fqaitjv">
          <p data-id="element-246" data-mp="28q2nw8cjbqsn">I've spoken with many physical therapists who told me the same thing:</p>
          <blockquote className="border-l-4 border-brand bg-brand-light px-5 py-4 font-display text-xl italic leading-snug text-navy" data-id="element-247" data-mp="23rhkk01zkqzz">
            “I know what I've studied… but when a patient with a herniated disc is sitting in front of me, I still have to
            think through every step from scratch.”
          </blockquote>
          <p data-id="element-248" data-mp="14d6drm3lgqzf">If you've ever felt that way, you're not alone.</p>
          <p data-id="element-249" data-mp="19b7zkesen4el">
            The problem isn't necessarily that you need another <strong className="text-ink" data-id="element-250" data-mp="vandn9r70sgv">20-hour course</strong>.
          </p>
          <p className="text-xl font-bold text-ink" data-id="element-251" data-mp="vcqe6npz23zu">You need a practical framework you can actually refer to.</p>
        </div>

        <div className="mt-10" data-id="element-252" data-mp="1nyj807tai8ah">
          <CtaButton label="I want a clear framework" caption="One-time payment of $27 · Instant access" data-id="element-253" data-mp="1o0ce9lzzqqhy" />
        </div>
      </div>
    </section>;
}